import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import controller from './sync-recommended-changes-dialog.controller';
import template from './sync-recommended-changes-dialog.html';
import syncOutstandingRecommended from '../syncOutstandingRecommended';
import approveChangeConfirmDialog from './dialog.approveChangeConfirmDialog';
import denyChangeConfirmDialog from './dialog.denyChangeConfirmDialog';
import syncableBatchChange from '../syncOutstandingRecommended/syncableBatchChange';

class dialogService {
  getOptions($event, {
    newChanges, changedIds, isNew, changesAreRecommended
  }) {
    return {
      controller,
      controllerAs: 'syncRecommendedChangesDialogVM',
      locals: {
        newChanges,
        changedIds,
        isNew,
        changesAreRecommended
      },
      targetEvent: $event,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.syncRecommendedChangesDialog', [
  alerts,
  confirmDialog,
  pmDataService,
  loaderService,
  constants,
  ssDialogService,
  syncOutstandingRecommended,
  approveChangeConfirmDialog,
  denyChangeConfirmDialog,
  syncableBatchChange
])
  .service('syncRecommendedChangesDialog', dialogService)
  .name;
